import { useEffect, useRef, useState } from "react";

// SVG Illustration: Risk Score Gauge
function RiskScoreIllustration() {
  return (
    <svg viewBox="0 0 380 220" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "auto" }}>
      <path d="M 60 180 A 130 130 0 0 1 320 180" stroke="#7c3aed" strokeWidth="3" fill="none" strokeLinecap="round" />
      {[...Array(9)].map((_, i) => {
        const angle = -180 + i * 22.5;
        const rad = (angle * Math.PI) / 180;
        const cx = 190, cy = 180, r1 = 120, r2 = 110;
        return (
          <line key={i}
            x1={cx + r1 * Math.cos(rad)} y1={cy + r1 * Math.sin(rad)}
            x2={cx + r2 * Math.cos(rad)} y2={cy + r2 * Math.sin(rad)}
            stroke="#7c3aed" strokeWidth="1.5" opacity="0.5" />
        );
      })}
      <circle cx="190" cy="50" r="6" fill="#a78bfa" />
      <line x1="190" y1="56" x2="190" y2="170" stroke="#7c3aed" strokeWidth="1.5" strokeDasharray="4 3" />
      <path d="M190 155 C183 148 174 138 174 130 C174 121 181.3 114 190 114 C198.7 114 206 121 206 130 C206 138 197 148 190 155Z"
        stroke="#a78bfa" strokeWidth="2" fill="none" />
      <text x="65" y="205" fill="#6b7280" fontSize="10" fontFamily="monospace">RISK SCORE:</text>
      <text x="140" y="205" fill="#a78bfa" fontSize="18" fontWeight="bold" fontFamily="monospace">51.53%</text>
      {[["Low", 290, 195], ["Moderate", 290, 208], ["High", 290, 221]].map(([label, x, y]) => (
        <g key={label}>
          <circle cx={x} cy={y - 3} r="3" fill="#7c3aed" opacity={label === "Low" ? 0.4 : label === "Moderate" ? 0.65 : 1} />
          <text x={x + 8} y={y} fill="#6b7280" fontSize="9" fontFamily="monospace">{label}</text>
        </g>
      ))}
    </svg>
  );
}

function MarketChartIllustration() {
  const bars = [18,22,28,35,20,15,40,55,38,28,50,65,48,35,55,70,52,40,60,72,58,45,35,50,65,48,38,55,42,30,48,60,45,35,50,62,47,36,28,42,55,40,30,45,58,43,33,48];
  const maxH = 72;
  const w = 340, h = 130;
  const barW = w / bars.length - 1.5;
  return (
    <svg viewBox={`0 0 ${w + 20} ${h + 20}`} fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "auto" }}>
      <defs>
        <clipPath id="dshape">
          <path d={`M 10 10 L ${w * 0.6} 10 Q ${w + 10} 10 ${w + 10} ${h / 2 + 10} Q ${w + 10} ${h + 10} ${w * 0.6} ${h + 10} L 10 ${h + 10} Z`} />
        </clipPath>
      </defs>
      <g clipPath="url(#dshape)">
        {bars.map((b, i) => (
          <rect key={i} x={10 + i * (barW + 1.5)} y={h + 10 - (b / maxH) * h} width={barW} height={(b / maxH) * h} fill="#7c3aed" opacity={0.5 + (b / maxH) * 0.5} rx="1" />
        ))}
      </g>
      <path d={`M 10 10 L ${w * 0.6} 10 Q ${w + 10} 10 ${w + 10} ${h / 2 + 10} Q ${w + 10} ${h + 10} ${w * 0.6} ${h + 10} L 10 ${h + 10} Z`}
        stroke="#7c3aed" strokeWidth="1.5" fill="none" opacity="0.4" />
    </svg>
  );
}

function InvestigationIllustration() {
  const edges = [
    [90, 50, 155, 130], [220, 50, 155, 130],
    [90, 50, 60, 160], [220, 50, 250, 160],
    [155, 130, 60, 160], [155, 130, 250, 160],
    [155, 130, 155, 210], [60, 160, 155, 210],
    [250, 160, 155, 210],
  ];
  const circleNodes = [{ x: 90, y: 50 }, { x: 220, y: 50 }, { x: 155, y: 210 }];
  const rectNodes = [{ x: 155 - 22, y: 130 - 18, w: 44, h: 36 }, { x: 60 - 22, y: 160 - 18, w: 44, h: 36 }, { x: 250 - 22, y: 160 - 18, w: 44, h: 36 }];
  return (
    <svg viewBox="0 0 340 260" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "auto" }}>
      <defs>
        <clipPath id="dshape2">
          <path d="M 10 10 L 200 10 Q 330 10 330 135 Q 330 260 200 260 L 10 260 Z" />
        </clipPath>
      </defs>
      <g clipPath="url(#dshape2)">
        {edges.map(([x1, y1, x2, y2], i) => (
          <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#7c3aed" strokeWidth="1.2" opacity="0.55" />
        ))}
        {rectNodes.map((r, i) => (
          <rect key={i} x={r.x} y={r.y} width={r.w} height={r.h} rx="4" stroke="#a78bfa" strokeWidth="1.5" fill="none" />
        ))}
        {circleNodes.map((c, i) => (
          <circle key={i} cx={c.x} cy={c.y} r="14" stroke="#a78bfa" strokeWidth="1.5" fill="none" />
        ))}
      </g>
      <path d="M 10 10 L 200 10 Q 330 10 330 135 Q 330 260 200 260 L 10 260 Z"
        stroke="#7c3aed" strokeWidth="1.5" fill="none" opacity="0.4" />
    </svg>
  );
}

const features = [
  {
    tag: "01",
    title: "Risk\nmitigation",
    description:
      "The underlying anonymity in digital assets leaves organizations vulnerable to hidden threats and allows malicious actors to slip through the cracks. elementuslabs leverages best-in-class attributions to provide KYT, sanctions detection, risk reporting, and 24/7 monitoring with alerts.",
    illustration: <RiskScoreIllustration />,
  },
  {
    tag: "02",
    title: "Market\nanalysis",
    description:
      "Capitalize on investment opportunities with a holistic view of the digital asset economy. Identify key players, analyze trading behaviors, conduct in-depth market research, and develop robust risk models with the edge needed to stay ahead.",
    illustration: <MarketChartIllustration />,
  },
  {
    tag: "03",
    title: "Investigation\nenablement",
    description:
      "Patented algorithms drive forensic on-chain investigations, from mapping intricate transactional patterns to revealing nested services and beneficial ownership with near real-time risk insights.",
    illustration: <InvestigationIllustration />,
  },
];

// Arrow icon component
function ArrowIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );
}

function FeatureCard({ f, index }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? "#fff" : "#1a1830",
        border: `1px solid ${hovered ? "#4c3a8a" : "#fff"}`,
        borderRadius: 20,
        color: hovered ? "#1a1830" : "#fff",
        padding: "32px 28px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 0,
        cursor: "pointer",
        transition: "background 0.3s, border-color 0.3s, transform 0.3s, box-shadow 0.3s",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        boxShadow: hovered ? "0 20px 60px rgba(124,58,237,0.18)" : "0 0 0 rgba(0,0,0,0)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Subtle top glow on hover */}
      <div style={{
        position: "absolute",
        top: 0, left: 0, right: 0,
        height: 2,
        background: "linear-gradient(90deg, transparent, #7c3aed, transparent)",
        opacity: hovered ? 1 : 0,
        transition: "opacity 0.3s",
      }} />

      {/* Title */}
      <h3 style={{
        fontSize: "clamp(1.6rem, 2.5vw, 2.4rem)",
        fontWeight: 600,
        color: hovered ? "#1a1830" : "#fff",
        margin: "0 0 20px",
        lineHeight: 1.1,
        letterSpacing: "-0.01em",
        whiteSpace: "pre-line",
      }}>
        {f.title}
      </h3>

      {/* Description */}
      <p style={{
        color: hovered ? "#000" : "#fff",
        fontSize: "0.875rem",
        lineHeight: 1.75,
        margin: "0 0 24px",
        flex: 1,
      }}>
        {f.description}
      </p>

      {/* Illustration box */}
      <div style={{
        background: "#13121f",
        border: "1px solid #2d2a4a",
        borderRadius: 14,
        padding: "16px 12px",
        overflow: "hidden",
        transition: "border-color 0.3s",
        borderColor: hovered ? "#3d2a6a" : "#2d2a4a",
      }}>
        {f.illustration}
      </div>
    </div>
  );
}

export default function Features() {
  return (
    <div style={{
      background: "#13121f",
      minHeight: "100vh",
      padding: "clamp(48px, 8vw, 80px) clamp(16px, 5vw, 48px)",
      boxSizing: "border-box",
      
    }}>

      {/* Header row */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "clamp(24px, 4vw, 40px)",
        marginBottom: "clamp(36px, 6vw, 56px)",
        maxWidth: 1280,
        margin: "0 auto clamp(36px, 6vw, 56px)",
      }}>
        <h2 style={{
          fontSize: "clamp(2rem, 5vw, 4rem)",
          fontWeight: 600,
          color: "#ffffff",
          margin: 0,
          lineHeight: 1.1,
          letterSpacing: "-0.02em",
        }}>
          Cut through the{" "}
          <span style={{
            color: "#ffffff",
            border: "2px solid #7c3aed",
            borderRadius: "999px",
            padding: "2px 20px 6px",
            display: "inline-block",
          }}>
            noise
          </span>
        </h2>

        <p style={{
          color: "#9ca3af",
          fontSize: "clamp(0.9rem, 1.5vw, 1.05rem)",
          lineHeight: 1.7,
          maxWidth: 720,
          margin: 0,
        }}>
          At elementuslabs, our goal is to arm organizations with the tools to make
          the best possible decisions — whether they're looking for compliance
          adherence, digital asset investigation, or market &amp; business intelligence.
        </p>
      </div>

      {/* Feature Cards Grid */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 300px), 1fr))",
        gap: "clamp(12px, 2vw, 20px)",
        maxWidth: 1280,
        margin: "0 auto clamp(40px, 6vw, 64px)",
      }}>
        {features.map((f, i) => (
          <FeatureCard key={i} f={f} index={i} />
        ))}
      </div>

      {/* CTA row */}
      <div style={{
        display: "flex",
        justifyContent: "center",
        maxWidth: 1280,
        margin: "0 auto",
      }}>
        <button
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#6d28d9";
            e.currentTarget.style.transform = "scale(1.03)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#7c3aed";
            e.currentTarget.style.transform = "scale(1)";
          }}
          style={{
            background: "#7c3aed",
            color: "#fff",
            border: "none",
            borderRadius: 999,
            padding: "clamp(12px, 2vw, 16px) clamp(32px, 5vw, 48px)",
            fontSize: "clamp(0.875rem, 1.5vw, 1rem)",
            fontWeight: 600,
            cursor: "pointer",
            letterSpacing: "0.01em",
            transition: "background 0.2s, transform 0.2s",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          Who We Serve
          <ArrowIcon size={16} />
        </button>
      </div>
    </div>
  );
}